const checkIsDoNotTrackEnabled = (): boolean => {
  // @ts-ignore
  const dnt = navigator.doNotTrack;
  // @ts-ignore
  const microsoftDnt = navigator.msDoNotTrack;

  return [dnt, microsoftDnt].some((value) => value === 'yes' || value === '1');
};

export const isDoNotTrackEnabled = checkIsDoNotTrackEnabled();
